import React, { useEffect, useState } from 'react'
import "../dark.css";

function DarkMode() {
    const [isLightMode, setIsLightMode] = useState(true);

 const toggleTheme = () => {
    setIsLightMode((prev) => !prev);
  };
  useEffect(() => {
    if (!isLightMode) {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  }, [isLightMode]);

 return (
  <div className="switch-box">
    <label id="switch" className="switch">
      <input
        type="checkbox"
        id="slider"
        checked={isLightMode}
        onChange={toggleTheme}
      />
      <span className="slider round"></span>
    </label>
  </div>
);
}

export default DarkMode